<template>
    <nav class="navbar navbar-expand-lg bg-light shadow-sm">
        <div class="container-fluid">
            <a class="navbar-brand" href="/dashboardpage">
                <img src="../../assets/images/logo.png" style="height: 50px; width: auto;">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 mt-2">
                    <li class="nav-item ml-4">
                        <router-link class="nav-link" :to="{name: 'Dashboard'}">
                            Dashboard
                        </router-link>
                    </li>
                    <li v-rolecheck="'ADMIN'" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                           aria-expanded="false">
                            Administration
                        </a>
                        <ul class="dropdown-menu">
                            <li>
                                <router-link class="dropdown-item" :to="{name:'Users'}">
                                    Users
                                </router-link>
                            </li>
                            <!--
                            <li>
                              <router-link class="dropdown-item" :to="{name:'Roles'}">
                                Roles
                              </router-link>
                            </li>
                            -->
                            <li>
                                <router-link class="dropdown-item" :to="{name:'Projects'}">
                                    Projects
                                </router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name:'LdapSync'}">
                                    LDAP Sync
                                </router-link>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="{name:'UserProject'}">
                                User Project
                              </router-link>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="{name:'UserRole'}">
                                User Role
                              </router-link>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="{name:'RolePermissions'}">
                                Role Permissions
                              </router-link>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="{name:'Resources'}">
                                Resources
                              </router-link>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li>
                                <a class="dropdown-item">
                                    Report an issue
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        To Manage
                      </a>
                      <ul class="dropdown-menu">
                        <li>
                          <router-link class="dropdown-item" :to="{name:'ManageMyProject'}">
                            Manage My Project
                          </router-link>
                        </li>
                      </ul>
                    </li>
                </ul>
                <div class="d-flex mx-4 pt-2 mobile-margin">
                    <div class="web-img">
                        <img src="../../assets/images/user.svg" width="50" height="28">
                    </div>
                    <span class="text-style"
                          style="margin-right: 8px;margin-top: 3px;"><strong> {{user.fullName}}</strong></span>
                    <span @click="logout" style="cursor: pointer" title="Logout">
              <!--<img src="../../assets/icons/signOutIcon.png" width="30" height="30">-->
                        <!--<font-awesome-icon icon="fa-solid fa-right-from-bracket" />-->
             <font-awesome-icon icon="sign-out-alt" size="lg" class="mt-1"/>
            </span>
                </div>
            </div>
        </div>
    </nav>
</template>


<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "AppHeader",
        data() {
            return {}
        },
        computed: {
            ...mapState("auth", ["user"]),

        },
        methods: {
            ...mapActions("auth", ["logout"]),

        }
    }
</script>

<style scoped>
    /*.navbar {*/
    /*    background-color: #fafafa;*/
    /*}*/

    /*.navbar-item:hover {*/
    /*    box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;*/
    /*}*/

    .navbar-collapse a, .text-style {
        font-family: Helvetica, Arial;
        font-size: 16px;
        color: #383838;
    }

    .nav-link {
        border-bottom: 2px solid transparent;
        transition: unset;
    }

    .nav-link:hover {
        border-bottom: 2px solid red;

    }

    .navbar-nav > li {
        margin-right: 30px;
    }

    .router-link-exact-active {
        border-bottom: 2px solid red;
    }

    @media (max-width: 992px) {
        .router-link-exact-active {
            border-bottom: unset;
        }

        .nav-link:hover {
            border-bottom: unset;
        }

        .web-img {
            display: none;
        }

        .mobile-margin {
            margin: unset !important;
        }
    }

    .bg-light {
        background-color: #ffffff !important;
    }

    .dropdown-item:active {
        background-color: #eaedf2;;
    }


</style>
